import Row from '@sdk/components/ui/spacing/Row';
import Text12 from '@sdk/components/ui/typography/Text12';
import styled from 'styled-components';

import { PREVIEW_LIST_ITEM_HEIGHT } from '@web/newsfeed/components/UserPreviewListModal/userPreviewListModal.consts';

export const RowContainer = styled(Row)`
  height: ${PREVIEW_LIST_ITEM_HEIGHT}px;
  border-bottom: 1px solid ${(props) => props.theme.colors.separatorOnWhite};
  align-items: center;

  &:first-child {
    margin-top: -8px;
  }

  &:last-child {
    border-bottom-color: transparent;
  }
`;

type LinkProps = {
  canNavigate?: boolean;
};
export const NameLink = styled(Text12)<LinkProps>`
  font-weight: bold;
  ${(props) => (props.canNavigate ? 'cursor: pointer' : '')};
  color: ${(props) => props.theme.colors.gray};

  &:hover {
    ${(props) => (props.canNavigate ? 'text-decoration: underline;' : '')};
  }
`;
